import { render, staticRenderFns } from "./DeviceInfoPerformaceDescongelarDuracao.vue?vue&type=template&id=1a8b8952&"
import script from "./DeviceInfoPerformaceDescongelarDuracao.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPerformaceDescongelarDuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports